/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Filters_DateInputs */

const es_billing_events_filters_date = /** @type {(inputs: Billing_Events_Filters_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por fecha`)
};

const en_billing_events_filters_date = /** @type {(inputs: Billing_Events_Filters_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by date`)
};

/**
* | output |
* | --- |
* | "Filter by date" |
*
* @param {Billing_Events_Filters_DateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_filters_date = /** @type {((inputs?: Billing_Events_Filters_DateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Filters_DateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_filters_date(inputs)
	return en_billing_events_filters_date(inputs)
});
export { billing_events_filters_date as "billing.events.filters.date" }